import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SelectItemButton from '../extras/partials/SelectItemButton';
import classNames from 'classnames';

const SpecializationItem = ({ index, program, rangeData, onAdd, onRemove, isSelected, refundable, selectedCampOptions, ranges}) => {

  const [selectedSpecialization, setSelectedSpecialization] = useState([]);
  console.log('setSelectedSpecialization:',selectedSpecialization);

  const [isWait, setIsWait] = useState(false);

  var isAnySelected = false;
  console.log('isAnySelected:', selectedCampOptions);
  if(Object.keys(selectedCampOptions).length){
    for (let program of rangeData.program_types) {
      if(selectedCampOptions[program.id] !== undefined){
        if(program.id === selectedCampOptions[program.id].id){
          isAnySelected = true;
        }
      }
    }
    for (let r = 0; r < ranges.length; r++) {
      for (let pt = 0; pt < ranges[r].program_types.length; pt++) {
        for (const [key, value] of Object.entries(selectedCampOptions)) {
          console.log('isAnySelected check',key,value);
          if(value.main_id !== undefined && value.main_id === ranges[r].program_types[pt].id){
            isAnySelected = true;
          }
          if(value.id === ranges[r].program_types[pt].id){
            isAnySelected = true;
          }
          if(value.top_id !== undefined && value.top_id === program.id){
            isSelected = true;
          }
        }
      }
    }
  }
  console.log('isAnySelected:',isAnySelected);

  const renderProgramDetails = (param) => {
    let params = param;
    switch(params) {
      case 'IMG Camp':
        return '<div class="desc"><p>The revolutionary IMG Academy methodology that includes elite sport instruction and core performance training.</p></div><div class="experience"><p>Designed for athletes still learning and refining their game.</p></div>';
      case 'Total Athlete':
        return '<div class="desc"><p>IMG CAMP</p><p>+</p><p>1 daily training specialization session</p></div><div class="experience"><p>Designed for athletes who want to enhance strength, speed, mental toughness or other areas of performance.</p></div>';
      case 'Breakthrough':
        return '<div class="desc"><p>IMG CAMP</p><p>+</p><p>1 daily personalized sport training session</p></div><div class="experience"><p>Designed for athletes who want to hone specific aspects of their game with customized coaching.</p></div>';
      case 'Game Changer':
        return '<div class="desc"><p>IMG CAMP</p><p>+</p><p>TOTAL ATHLETE</p><p>+</p><p>BREAKTHROUGH</p></div><div class="experience"><p>Designed for athletes who want the ultimate training experience to transform their game.</p></div>';
      default:
        return '';
    }
  }

  var mainprice = program.price;
  if(refundable === 'Flexible' && program.price_flexible){
    mainprice = program.price_flexible;
  } else if (refundable === 'Refundable' && program.price_refundable){
    mainprice = program.price_refundable;
  }


  var select_disabled = false;
  if(program.sold_out){
    select_disabled = true;
  }
  if(isAnySelected && !isSelected){
    select_disabled = true;
  }

  var concentrations_disabled = false;
  if(isSelected || isAnySelected){
    concentrations_disabled = true;
  }

  var global_soldout = false;
  var listConcentrations = [];
  var hasConcentrations = false;
  var hasESLselected = false;
  var weeknum = 1;
  console.log('listConcentrations-0:',program);
  if(program.display_concentration_step){
    console.log('listConcentrations-1:',ranges);
    console.log('listConcentrations-2:',ranges.length);
    for (let i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      console.log('listConcentrations-3:',range);
      if(range.concentrations !== undefined && range.concentrations.length){
        range.concentrations[0].label = 'Week '+(i+1)+' Specialization';
        listConcentrations.push(range.concentrations);
        hasConcentrations = true;
      }
      if(range.concentrationsWeeks !== undefined && range.concentrationsWeeks.length){
        for (let rc = 0; rc < range.concentrationsWeeks.length; rc++) {
          range.concentrationsWeeks[rc][0].label = 'Week '+weeknum+' Specialization';
          listConcentrations.push(range.concentrationsWeeks[rc]);
          hasConcentrations = true;
          weeknum++;
        }
      }
      for (let ii = 0; ii < range.program_types.length; ii++) {
        var program_type = range.program_types[ii];
        if(program_type.name === program.name && program_type.sold_out){
          select_disabled = true;
          concentrations_disabled = true;
          global_soldout = true;
        }
      }
    }
    if(selectedSpecialization.length !== listConcentrations.length){
      select_disabled = true;
    }
    if(selectedSpecialization.length){
      for (let i = 0; i < selectedSpecialization.length; i++) {
        if(selectedSpecialization[i].value === '0'){
          select_disabled = true;
        }
        if(selectedSpecialization[i].value === '1'){
          hasESLselected = true;
        }
      }
    }
  }

  // Remove ESL for next selections
  console.log('LConcentrationsLast0:',hasESLselected);
  if(hasESLselected){
    select_disabled = false;
  }
  console.log('LConcentrationsLast1:',listConcentrations);
  /*
  if(listConcentrations.length > 1){
    for (let i = 1; i < listConcentrations.length; i++) {
      for (let ii = 0; ii < listConcentrations[i].length; ii++) {
        if(parseInt(listConcentrations[i][ii].value) === 1){
          listConcentrations[i].splice(ii, 1);
        }
      }
    }
  }
  console.log('LConcentrationsLast2:',listConcentrations);

  console.log('listConcentrations-4:',listConcentrations);
  console.log('listConcentrations-5:',ranges);
  */

  useEffect(() => {
   console.log('selectedSpecialization:',selectedSpecialization);
  },[selectedSpecialization])

  const callOnAdd = async () => {
    setIsWait(true);
    const start = Date.now();
    console.log('OnAdd start');
    await onAdd(program, selectedSpecialization, ranges);
    const end = Date.now();
    console.log(`OnAdd end: ${end - start} ms`);
    setIsWait(false);
  };

  const callOnRemove = async () => {
    setIsWait(true);
    const start = Date.now();
    console.log('onRemove start');
    setSelectedSpecialization([]);
    await onRemove(program, ranges);
    const end = Date.now();
    console.log(`onRemove end: ${end - start} ms`);
    setIsWait(false);
  };

  return (
    <div className={classNames('program-type', {
          'program-type-disabled': (isAnySelected && !isSelected),
          'program-type-sold-out': global_soldout,
          'imgc': program.display_name==="IMG Camp",
          'ta': program.display_name==="Total Athlete",
          'bt': program.display_name==="Breakthrough",
          'gc': program.display_name==="Game Changer",
         }
       )} key={`${index}`}>
      <div className="program-type-topblock">
        <div className={`program-top-${index}`}>
        </div>
      </div>
      <div className="program-type-top">
        <div className="program-type-length">
          {program.secondary_group}
        </div>
        <div className="programname">{program.display_name}</div>
      </div>
      <div className="program-type-bottom">
        <div className="program-type-price">
          ${mainprice.toLocaleString()}
        </div>
        <div className="programNameDetails" dangerouslySetInnerHTML={{ __html: renderProgramDetails(program.display_name) }}>
        </div>
        <div className="buttonsHolder">
          {hasConcentrations &&
            <div>
              {listConcentrations.map((concentration, index) => {
                var selectedSpecializationValue = '0';
                for (let i = 0; i < selectedSpecialization.length; i++) {
                  if(selectedSpecialization[i].id === `${program.id}-${index}-specializations`){
                    selectedSpecializationValue = selectedSpecialization[i].value;
                  }
                }
                if(hasESLselected && index === 0 && !isSelected){
                  concentrations_disabled = false;
                } else if(hasESLselected && index !== 0) {
                  concentrations_disabled = true;
                  selectedSpecializationValue = 1;
                }
                console.log('selectedSpecializationValue',selectedSpecializationValue);
                return (
                  <div className="program-type-specializations" key={`${index}`}>
                    <label className={classNames('field__label')}>
                      <select
                        name={`${program.id}-${index}-specializations`}
                        onChange={(e) => {
                          const value = e.target.value;
                          var is_exist = false;
                          for (let i = 0; i < selectedSpecialization.length; i++) {
                            if(selectedSpecialization[i].id === `${program.id}-${index}-specializations`){
                              is_exist = true;
                            }
                          }
                          if(is_exist){
                            setSelectedSpecialization(
                                selectedSpecialization.map((specialization) =>
                                    specialization.id === `${program.id}-${index}-specializations`
                                        ? {
                                              ...specialization,
                                              value: value,
                                              week: index+1,
                                          }
                                        : { ...specialization }
                                )
                            );
                          } else {
                            setSelectedSpecialization((prevSpecialization) => [
                                ...prevSpecialization,
                                {
                                    id: `${program.id}-${index}-specializations`,
                                    value: value,
                                    week: index+1,
                                },
                            ]);
                          }
                        }}
                        defaultValue={selectedSpecializationValue}
                        value={selectedSpecializationValue}
                        disabled={concentrations_disabled}
                      >
                      {concentration.map((value) => {
                        if (!hasESLselected && value.value === 1 && index !== 0) {
                          return null;
                        }
                        return (
                          <option value={value.value}>
                            {value.label}
                          </option>
                        );
                      })}
                      </select>
                    </label>
                  </div>
                );
              })}
            </div>
          }
          <SelectItemButton
            isSelected={isSelected}
            onAdd={callOnAdd}
            onRemove={callOnRemove}
            disabled={select_disabled}
            soldOut={global_soldout}
            isWait={isWait}
          />
        </div>
      </div>
    </div>
  );
};

SpecializationItem.propTypes = {
  index: PropTypes.number,
  program: PropTypes.object.isRequired,
  rangeData: PropTypes.object.isRequired,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  isSelected: PropTypes.bool,
  refundable: PropTypes.string,
  selectedCampOptions: PropTypes.object,
  ranges: PropTypes.array
};

export default SpecializationItem;
